import React, { useEffect, useRef, useState } from "react";
import styles from "./scss/chatbottom.module.scss";
// // import ReactQuill from 'react-quill'; // Typescript
import "react-quill/dist/quill.snow.css";
import { Modal, Popover, Menu, Tooltip, Divider, Dropdown } from "antd";
import ChatBottomAttachments from "../chatWidgets/chatBottomAttachment";
import ChatReplyInner from "../chatWidgets/chatReplyInner";
import replyIcon from "../../../styles/images/reply-svg.svg";
import ChatAudioRecording from "../chatWidgets/chatAudioRecording";
import { URChatAttached } from "../../../shared/widgets/chatAttached";
import { URChatEmoji } from "../../../shared/widgets/chatEmoji";
import { ChatService } from "../../../base/chatService";
import { URButton } from "../../../shared/widgets/button";
import { chats, chatSocketReducerStateModel, chatwindowDetails, initialStateModel, typingReducerModel } from "../../../models/model";
import { useSelector } from "react-redux";
import store from "../../../context/store/store";
import { Cookie, getCaretCharacterOffsetWithin, urlify, urlifySW } from "../../../base/utils";
import _ from "lodash";
import { URAtMention } from "../../../shared/widgets/atMention";
import { DraftService } from "../../../base/draftService";
import { SocketChatService } from "../../../base/socketChatService";
import { chatWindowResize, filesUploadApiSocket, fileTextAttachment, fileUploadSocket, generateChatID, userInfo } from "../../../base/socketChatService/utils";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import { updateFileAttach } from "../../../base/socketChatService/newChat";
import { getComposedMessage, getUnreadCompose, resetValue, toastInformation } from "../../../base/callService/common";
import { Types, actionTypes } from "../../../context/action/action";
import sendgreendisable from "../../../styles/images/sendGreen.svg";
import sendgreen from "../../../styles/images/sendGreenDisable.svg";
import msgcomposer from "../../../styles/images/msgcomposer.svg";
import { URInputwithLabel } from "../../../shared/widgets/inputwithLable";

let typingTimer: any = null;
const MicRecorder = require("mic-recorder-to-mp3");

type chatBottomState = {
  textMessage: any;
  isMention: boolean;
  mentionUsers: Array<string>;
  isEmoji: boolean;
  teammemberdetails: any;
  searchmemberdetails: any;
  showRecorder: boolean;
  isGif: boolean;
  isSticker: boolean;
  linkText: any;
  linkUrl: any;
  addLinkRes: any;
  activeType: any;
  emojiIndex: any;
  copypaste: boolean;
  txtleng: any;
  mentionIndex: any;
};

function ChatBottom({ scroll }: any) {
  const [modal1Open, setModal1Open] = useState(false);
  const [showAttachToolTip, setShowAttachToolTip] = useState(false);
  const [word, setWord] = useState('');


  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  const { filesAttach, fileTexttype, isEmojiWindow,messageList}: chatSocketReducerStateModel = useSelector(
    (state: initialStateModel) => state.chatSocketReducerState
  );
  const [isModalVisible1, setIsModalVisible1] = useState(false);

  const [recording] = useState<any>({
    recorder: new MicRecorder({
      bitRate: 128
    })
  });
  const [selection, setSelection] = useState<any>({
   startIdx:-1,endIdx:-1
  });


  const showModal1 = () => {
    setIsModalVisible1(true);
  };


  const [showEvent, setOpenEventModal] = useState(false);
  //const [showTask, setOpenTaskModal] = useState(false);
  const [showAttach, setOpeAttachModal] = useState(false);
  const [showBlock, setBlockquote] = useState(false);
  const [aiMsgOpt, setAiMsgOpt] = useState('Formal');
  const { typingList }: typingReducerModel = useSelector((state: initialStateModel) => state.typingReducerState);
  let { userdetails, dropdownNewChat }: any = store.getState().loginReducer;
  let ctrlKey = useRef<any>();
  let chatwindowDetails: any = store.getState().chatWindowReducer?.chatWindowDetails;
  let editDraft: any = store.getState().chatWindowReducer?.editDraft;
  let { draftContact }: any = store.getState().recentchatReducer;
  let {composedMsg,intent,aiAssistMessage,countValue}:any=store.getState().chatReducer;
  let allContacs: any = store.getState().contactReducer;
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  let deleteContact = allContacs?.deleteContacts;
  const isTypingOn: any = useRef(0);
  //const timeoutRef = useRef<any>(null);
  const draftRef: any = useRef(0);
  const socketService = useRef<any>(null);
  const inputFileRef: any = React.useRef(null);
  let { chatWindowDetails, newUserMembers, isNewMessageWindow, multiMemberList, windowResize }: chatwindowDetails =
    allReducer.chatWindowReducer;
  const indexValue = draftContact.findIndex((value: any) => {
    if (isNewMessageWindow) {
      return value?.contactDetail === 'newWindow'
    } else {
      return chatWindow.chatWindowDetails?.team_id ? value?.contactDetail?.team_id === chatWindow.chatWindowDetails?.team_id : value?.contactDetail?.sip_login_id === chatWindow.chatWindowDetails?.sip_login_id
    }
  });

  const teamMembers = chatWindow.chatWindowDetails?.team_members?.replace(/\s/g, "").split(",");
  const userDetails = userInfo();
  const sendFileMessage = () => {
    let { textMessage, mentionUsers } = messageInfo;
    if (isEditing) {
      message.text['text'] = textMessage
      socketService?.current?.chatEditMessage(message?.id, '');
      updateFileAttach([]);
      setMessageInfo({
        ...messageInfo,
        textMessage: "",
        isMention: false,
        isGif: false,
        isSticker: false,
        mentionUsers: []
      });
      const textClr: any = document.getElementById('textedited');
      textClr.textContent = '';
      if (Array.isArray(draftContact) && draftContact.length > 0) {
        DraftService.removeDraftMessage(chatwindowDetails, "");
      }
      chatWindowResize(54);
      if (editMessageDetails?.isEditing) {
        ChatService.onChangeEditWindow(false, "");
      }
    } else {
      let { textMessage, mentionUsers } = messageInfo;
      let mention_list = _.map(mentionUsers, "sip_login_id");
      if (filesAttach?.length > 0) {
        filesUploadApiSocket(filesAttach, textMessage, '', mention_list);
        updateFileAttach([]);
        setMessageInfo({
          ...messageInfo,
          textMessage: "",
          isMention: false,
          isGif: false,
          isSticker: false,
          mentionUsers: []
        });
        const textClr: any = document.getElementById('textedited');
        textClr.textContent = '';
        if (Array.isArray(draftContact) && draftContact.length > 0) {
          DraftService.removeDraftMessage(chatwindowDetails, "");
        }
        chatWindowResize(54);
        if (editMessageDetails?.isEditing) {
          ChatService.onChangeEditWindow(false, "");
        }
      }
    }
  };

  const selectMsgComposerOpt=(type:any)=>{
    getComposedMessage(word ? word : messageInfo.textMessage,type,chatWindowDetails);
  }

  let { editMessageDetails, replyMessageDetails, fileList }: chats = allReducer.chatReducer;
  let { isEditing, message } = editMessageDetails;
  let { isReply, replymessage } = replyMessageDetails;
  const [messageInfo, setMessageInfo] = useState<chatBottomState>({
    textMessage: indexValue > -1 ? draftContact[indexValue].msgText : "",
    isMention: false,
    mentionUsers: [],
    isEmoji: false,
    teammemberdetails: chatWindowDetails?.teammembersdetails,
    searchmemberdetails: chatWindow.chatWindowDetails?.teammembersdetails,
    showRecorder: false,
    isGif: false, copypaste: false, txtleng: 0, mentionIndex: 0,
    isSticker: false, linkText: "", linkUrl: "", addLinkRes: [], activeType: [], emojiIndex: 0
  });

  const menuai = (
    messageInfo?.textMessage && messageInfo?.textMessage?.trim() !== ""
    ? (
<Menu>
  <Menu.Item onClick={()=>selectMsgComposerOpt("Formal")}>Formal</Menu.Item>
  <Menu.Item onClick={()=>selectMsgComposerOpt("Informal")}>Informal</Menu.Item>
  <Menu.Item onClick={()=>selectMsgComposerOpt("Expand")}>Expand</Menu.Item>
  <Menu.Item onClick={()=>selectMsgComposerOpt("Concise")}>Concise</Menu.Item>
  <Menu.Item onClick={()=>selectMsgComposerOpt("Regenerate")}>Regenerate</Menu.Item>
</Menu>
    )
    :
    ''
);

useEffect(()=>{
  if(scroll < -10)
  {
    store.dispatch({
      type:Types.SCROLL_UNREAD,
      payload:{
        scrollUnread:true
      }
    })
  }
  else if(scroll === 0)
  {
    store.dispatch({
      type:Types.SCROLL_UNREAD,
      payload:{
        scrollUnread:false
      }
    })
      store.dispatch({
          type: Types.COUNT_VALUE,
          payload: {
              countValue: 0
          }
      })
  }

},[scroll,JSON.stringify(chatSocketMessage.messageList)])


  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketService.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
    const textClr: any = document.getElementById('textedited');

    if (textClr !== null) {
      textClr.textContent = '';
      textClr.focus()
    }
    document.onkeydown = function (e: any) {
      if (e.key === "Control") {
        ctrlKey.current = "Alt";
      } else if (e.key === "a" && e.altKey) {
        ctrlKey.current = "";
        openRecorder();
      } else if (e.ctrlKey || e.key === "Meta") {
        ctrlKey.current = "Ctrl";
      } else if (e.key === "u" && ctrlKey.current === "Ctrl" && inputFileRef?.current) {
        inputFileRef.current.click();
        ctrlKey.current = "";
      } else if (e.key === "u" && e.ctrlKey && inputFileRef?.current) {
        inputFileRef.current.click();
        ctrlKey.current = "";
      } else if (e.key === "u" && e.altKey) {
        setOpeAttachModal(true);
      }
    };
    window.addEventListener("paste", fileHandler);
    return () => {
      window.removeEventListener("paste", fileHandler);
    };
  }, [inputFileRef]);


  useEffect(() => {
    document.addEventListener("keydown", function (event: any) {
      if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.keyCode === 57) {
        blockFormatContent('formatBlock');
      }
      else if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.keyCode === 55) {//7
        boldTextContent('insertUnorderedList');
      }
      else if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.keyCode === 56) {//8
        boldTextContent('insertOrderedList');
      }
      else if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.key.toLowerCase() === 'b') {
        boldTextContent('strikeThrough');
      }
      else if (event.metaKey && event.key.toLowerCase() === 'b') {
        boldTextContent('bold')
      } else if (event.metaKey && event.key.toLowerCase() === 'i') {
        boldTextContent('italic')
      }

    })
  }, [])


  const fileHandler = (event: any) => {
    const textClr: any = document.getElementById('textedited');
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;
    let cliphtml = event.clipboardData.getData('text/html');
    let clipDta = cliphtml?.replace(/(<([^>]+)>)|&nbsp;/gi, " ")
    if (clipDta?.trim() === '') {
      for (let index in items) {
        const item = items[index];
        if (item.kind === "file") {
          let file = item.getAsFile();
          let filesinfo: any = {};
          filesinfo.fileName = file.name;
          filesinfo.fileType = file.type;
          filesinfo.filePath = window.URL.createObjectURL(file);
          filesinfo.filesize = file.size;
          filesinfo.targetFile = file;
          filesinfo.text = '';
          filesinfo.txt = '';
          filesinfo.messageType = "FILE";
          ChatService.fileUpload(filesinfo);
        }
      }
    }

  };

  const handleEmojiChange = (emojiData: any) => {
    let { textMessage, emojiIndex, txtleng } = messageInfo;
    let add: any = emojiIndex + ((textMessage?.length - txtleng));
    let conactedMessage: any = textMessage !== "" && textMessage?.length !== undefined ?
      textMessage?.slice(0, add) + emojiData + textMessage?.slice(add) : emojiData;
    setMessageInfo({ ...messageInfo, textMessage: conactedMessage });
    let emj: any = document.getElementById("textedited");
    emj.innerHTML = conactedMessage;
    setRangeFocus();
  };

  const sendMessageToXMPP = (event: any) => {
    if (
      (isNewMessageWindow && Array.isArray(newUserMembers) && newUserMembers.length > 1) ||
      !_.isEmpty(chatWindow?.chatWindowDetails)
    ) {
      let data = {
        from: userDetails?.fromID.toString(),
        to: chatWindow?.chatWindowDetails?.team_id
          ? teamMembers?.toString()
          : chatWindow.chatWindowDetails?.sip_login_id?.toString(),
        chatId: chatWindow?.chatWindowDetails?.team_id ? chatWindow.chatWindowDetails?.team_id.toString() : ""
      };
      socketService?.current?.chatTypingStopped(data);
      event.preventDefault();
      let { textMessage, mentionUsers } = messageInfo;
      if (
        ((textMessage?.trim() === "") || (messageInfo?.textMessage?.replace(/<br\s*\/?>|&nbsp;/gi, ' ').trim() === "") || textMessage === undefined) &&
        Array.isArray(fileList) &&
        fileList.length === 0 &&
        Array.isArray(filesAttach) &&
        filesAttach.length === 0
      ) {
        let toast: string = "Please enter a message";
        toastInformation(toast, "success");
        return;
      }

      if (isEditing) {
        let { textMessage } = messageInfo;
        if (message?.id && message?.id?.message?.messageType === 'IMAGE') {
          message.id.message['messageType'] = 'TEXT';
          message.id.message['body'] = textMessage;
        }

        socketService?.current?.chatEditMessage(message?.id, textMessage);
        ChatService.onChangeEditWindow(false, "");
        //ChatService.editMessage(message.id, textMessage);
      } else if (isReply) {
        if (filesAttach?.length > 0) {
          filesUploadApiSocket(filesAttach, textMessage, replyMessageDetails, '');
          updateFileAttach([]);
          ChatService.onChangeReplyWindow(false, "");
        } else {
          if (chatwindowDetails?.sip_login_id) {
            socketService?.current?.NewChat(textMessage, null, replyMessageDetails);
          } else {

            let textRes: any = mentionUsers?.length > 0 ? textMessage?.replace(/<\/?span[^>]*>|&nbsp;/g, " ") : textMessage;
            let mention_list = _.map(mentionUsers, "sip_login_id");
            socketService?.current?.sendGroupChat(textRes, chatwindowDetails, mention_list, replyMessageDetails);
          }
        }
      } else {
        let mention_list = _.map(mentionUsers, "sip_login_id");
        const socketChat = new SocketChatService(userInfo()?.fromID, userInfo()?.domainId);

        if (
          ((Array.isArray(newUserMembers) && newUserMembers.length === 0) ||
            chatwindowDetails?.sip_login_id ||
            chatwindowDetails?.team_id) &&
          (!newUserMembers || newUserMembers.length <= 1)
        ) {
          if (chatwindowDetails?.sip_login_id) {
            socketChat.NewChat(textMessage, null);
          } else {
            let textRes: any = textMessage?.replace(/<\/?span[^>]*>|&nbsp;/g, " ")
            socketChat.sendGroupChat(textRes, chatwindowDetails, mention_list);
          }
        } else if (newUserMembers && Array.isArray(newUserMembers) && newUserMembers.length > 1) {
          socketChat.createNewMessageGroup(textMessage);
        }
      }
      if (Array.isArray(draftContact) && draftContact.length > 0) {
        const newWindowValue = draftContact?.findIndex((value: any) => {
          if (isNewMessageWindow) {
            return value?.contactDetail === 'newWindow'
          }
        });
        let newvalue = isNewMessageWindow && newWindowValue === 0 ? "newWindow" : ""
        DraftService.removeDraftMessage(chatwindowDetails, newvalue);
      }

      setMessageInfo({
        ...messageInfo,
        textMessage: "",
        isMention: false,
        searchmemberdetails: chatWindowDetails?.teammembersdetails,
        mentionUsers: [], activeType: [], txtleng: 0
      });
      const textClr: any = document.getElementById('textedited');
      textClr.textContent = '';
      store.dispatch({
        type:Types.SET_ARR_BUFFER,
        payload:{
          aiSessionId:"",
          arrayBuffer:[],
          intent:"",
          aiAssistMessage: ""
        }
      })
      store.dispatch({
        type: actionTypes.FILE_TEXT_MESSAGE,
        payload: {
          fileTextMessage: "",
          fileTexttype: 0
        }
      });
      chatWindowResize(54);
    }
  };

  const handleKeyPress = (e: any) => {
    setModal1Open(false);
    if (e.metaKey && e.key === 'b') {
      boldTextContent('bold')
    } else if (e.metaKey && e.key === 'i') {
      boldTextContent('italic')
    }
    if (e.altKey && e.key === "Enter") {
      let find = messageInfo?.activeType.findIndex((x: any) => (x === 'insertOrderedList' || x === 'insertUnorderedList'));
      navigator.userAgent.indexOf("Firefox") !== -1 && document.execCommand('insertLineBreak', false, '<br>')
      navigator.userAgent.indexOf("Chrome") !== -1 && document.execCommand('insertLineBreak', false, '<br>')

      if (find > -1) {
        if (navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1) {
          document.execCommand("insertHTML", false, "</li>");
        } else {
          document.execCommand("insertHTML", false, "<li></li>");
        }
      }
      // prevent the default behaviour of return key pressed
      return false;
    }
    if (e.shiftKey && e.key === "Enter") {
      let find = messageInfo?.activeType.findIndex((x: any) => (x === 'insertOrderedList' || x === 'insertUnorderedList'));
      // navigator.userAgent.indexOf("Safari") !== -1 && document.execCommand('insertHTML', false, '<br>')
      if (find > -1) {
        if (navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1) {
          document.execCommand("insertHTML", false, "</li>");
        }
        else {
          document.execCommand("insertHTML", false, "<li></li>");
          var debounce_fun = _.debounce(function () {
            const textClr: any = document.getElementById('textedited');
            let data = textClr.innerHTML.replace('<br><br>', '<br>')
            textClr.innerHTML = data;
            textClr.focus();
            setRangeFocus();
          }, 1);

          debounce_fun();
        }
      }
      return false;
    } else {
      if (e.key === "Enter" && Array.isArray(filesAttach) && filesAttach.length > 0) {
        if (!isReply) {
          sendFileMessage();
          e.preventDefault();
        } else {
          sendMessageToXMPP(e);
        }
      } else if (e.key === "Enter" && ((messageInfo?.textMessage?.trim() === "") || (messageInfo?.textMessage?.replace(/<br\s*\/?>|&nbsp;/gi, ' ').trim() === "")) && !messageInfo.showRecorder) {
        const keyCode = e.which || e.keyCode;
        if (keyCode === 13) {
          let toast: string = "Please enter a message";
          toastInformation(toast, "success");
          e.preventDefault();
        }
      } else if (e.key === "Enter" && messageInfo.showRecorder) {
        const keyCode = e.which || e.keyCode;
        if (keyCode === 13) {
          sendAudio();
          e.preventDefault();
        }
      } else if (e.altKey && e.key === "Enter") {
        const textClr: any = document.getElementById('textedited');
        messageInfo.textMessage = messageInfo.textMessage + "<br>";
        textClr.innerHTML = messageInfo.textMessage + "<br>";
        textClr.focus();
      }
      else if (
        (e.key === "Enter" && messageInfo?.textMessage?.trim() !== "") ||
        (Array.isArray(fileList?.length) && fileList?.length > 0)
      ) {
        if (e.keyCode === 13) {
          sendMessageToXMPP(e);
        }
        if (e.key === "Backspace" || e.key === "Delete") {
          let { mentionUsers } = messageInfo;
          const stringLength = e?.target?.value?.length;
          var lastIndex = e?.target?.value?.lastIndexOf("@");
          var deltedString = e?.target?.value.slice(lastIndex, stringLength - 1).replace("@", "");

          var status = false;
          const filteredFinalIDS = mentionUsers.filter((value: any) => {
            if (value.caller_id.includes(deltedString)) {
              status = true;
            }
            return !value.caller_id.includes(deltedString);
          });
          if (status && lastIndex > -1) {
            setMessageInfo({
              ...messageInfo,
              mentionUsers: filteredFinalIDS
            });
          }
        }
      }
    }

    /*   if (e.keyCode === 13 && e.shiftKey && enterLines < 17) {
    
        let element: HTMLElement | any = document.getElementById('chatWindow') || null;
        
        if(element){
    
         let exHeight =  element.clientHeight;
         exHeight =  exHeight-20
          element.style.setProperty('height', exHeight+'px');
        }
      }
       if (e.keyCode === 8 && lines > 1 && lines !== enterLines) {
    
        let element: HTMLElement | any = document.getElementById('chatWindow') || null;
        
        if(element){
    
         let exHeight =  element.clientHeight;
         exHeight =  exHeight+20
          element.style.setProperty('height', exHeight+'px');
        }
        console.log("backspace pressed");
      }  */
  };

  const getUserSuggestions = (userList: any, keyword: any) => {
    if (Array.isArray(userList)) {
      if (!keyword || keyword.slice(1) === "") {
        return userList;
      } else {
        return _.filter(userList, function (data: any) {
          let caller_id = data?.caller_id || "";
          let ext = data?.ext || "";
          return (
            caller_id.toLowerCase().indexOf(keyword?.slice(1)?.toLowerCase()) !== -1 ||
            ext.toString().indexOf(keyword?.slice(1)?.toLowerCase()) !== -1
          );
        });
      }
    }
  };

  const appendMentionUser = (data: any) => {
    const finalCallerid: any = {};

    finalCallerid["caller_id"] = data?.caller_id;
    finalCallerid["sip_login_id"] = data?.sip_login_id;
    finalCallerid["jid"] = data?.jid;

    let mentions_id_Array = messageInfo?.mentionUsers;

    let mindex = _.findIndex(mentions_id_Array, function (o: any) {
      return o?.sip_login_id === data?.sip_login_id;
    });

    if (mindex === -1) mentions_id_Array.push(finalCallerid);

    const lastindexOfString = messageInfo?.textMessage;
    var lastIndex = messageInfo.mentionIndex > 0 ? (messageInfo.mentionIndex - 1) : lastindexOfString.lastIndexOf("@");

    var substringValue = lastindexOfString.substring(0, lastIndex) + "@";
    var laststringValue = messageInfo.mentionIndex > 0 ? lastindexOfString.substring((lastIndex + 1), lastindexOfString?.length) : " ";
    let text = substringValue + data?.caller_id + laststringValue;
    setMessageInfo({ ...messageInfo, textMessage: text, mentionUsers: mentions_id_Array, isMention: false });
    const textClr: any = document.getElementById('textedited');
    let arr: any = mentions_id_Array;
    let datClr = urlifySW(arr, text);
    textClr.innerHTML = datClr + "&nbsp; ";
    if (textClr !== null) {
      setRangeFocus();
    }
    if (filesAttach?.length > 1) {
      fileTextAttachment(fileTexttype, datClr)
    }

  };

  const getlastWord = (words: any) => {
    var n = words.split(" ");
    return n[n.length - 1];
  };
  const debounceFn = (inputValue: any) => {
    let chatDetails: any = chatwindowDetails?.team_id
      ? chatwindowDetails?.team_id
      : chatWindowDetails?.sip_login_id || "newWindow";
    let chatRes: any = chatDetails === "newWindow" ? "newWindow" : chatwindowDetails
    let textInfo: any = document.getElementById("textedited")?.textContent || "";
    if (isNewMessageWindow && textInfo !== "") {
      DraftService.updateDraftMessage(chatRes, inputValue);
    } else if (chatDetails !== "" && textInfo !== "") {
      DraftService.updateDraftMessage(chatWindowDetails, inputValue);
    }
  };


  const onUpdateMessage = (event: any) => {
    const textClr: any = document.getElementById('textedited');
    const specialChars = /<\/?b[^>]*>|<\/?i[^>]*>|<\/?strike[^>]*>|<\/?li[^>]*>|<\/?div[^>]*>/;
    let notallowed: any = specialChars.test(textClr.innerHTML);
    var str = notallowed ? textClr.innerHTML.replace(/<\/?span[^>]*>|<\/?a[^>]*>|&nbsp;/g, "") :
      textClr.innerHTML.replace(/(<([^>]+)>)|&nbsp;/gi, " ");
    if (messageInfo.copypaste) {
      var strRes = textClr.innerHTML.replace(/<\/?p[^>]*>|<\/?div[^>]*>|<\/?tr[^>]*>/gi, "<br> ").replace(/<\/?td[^>]*>/gi, " ")
      var str = messageInfo.activeType?.length > 0 ? textClr.innerHTML.replace(/<\/?span[^>]*>|<\/?a[^>]*>|<\/?p[^>]*>|&nbsp;/g, "") :
        strRes.replace(/<(?!br\s*\/?)[^>]+>/g, '').replace(/(\<br[\s]*\/?\>[\s]*)+/g, '<br/> ').replace(/^(<br\s*\/?>)+/, '');

      const mention_mem: Array<any> = chatWindowDetails?.teammembersdetails || [];
      mention_mem && mention_mem.map((value: any) => {
        const callerID = value?.caller_id.toString();
        if (_.includes(str, callerID)) {
          const finalCallerid: any = {};
          finalCallerid["caller_id"] = value?.caller_id;
          finalCallerid["sip_login_id"] = value?.sip_login_id;
          finalCallerid["jid"] = value?.jid;
          let mentions_id_Array = messageInfo?.mentionUsers;

          let mindex = _.findIndex(mentions_id_Array, function (o: any) {
            return o?.sip_login_id === value?.sip_login_id;
          });

          if (mindex === -1) mentions_id_Array.push(finalCallerid);
          setMessageInfo({ ...messageInfo, textMessage: str, mentionUsers: mentions_id_Array });

        }
        var re = new RegExp(`${"@" + (callerID)}`, 'g');
        str = str.replace(re,
          '<span class="' + styles.atMention + '">@' + callerID + '</span>');
      });

      textClr.innerHTML = urlify(str);
      setRangeFocus();
      setMessageInfo({ ...messageInfo, copypaste: false });
    }
    let textInfo: any = document.getElementById("textedited")?.textContent || "";
    var strRes = textInfo !== "" ? str.replace(/^<br\s*\/?>|<br\s*\/?>$/g, '') : '';
    setMessageInfo({ ...messageInfo, textMessage: strRes, emojiIndex: str?.length, copypaste: false });
    if (filesAttach.length > 1) {
      fileTextAttachment(fileTexttype, strRes)
    }

    if (isTypingOn.current === 0) {
      isTypingOn.current = 1;
      let data = {
        from: userDetails?.fromID.toString(),
        to: chatWindow?.chatWindowDetails?.team_id
          ? teamMembers?.toString()
          : chatWindow?.chatWindowDetails?.sip_login_id?.toString(),
        chatId: chatWindow?.chatWindowDetails?.team_id
          ? chatWindow?.chatWindowDetails?.team_id?.toString()
          : generateChatID(userDetails?.fromID, chatWindow?.chatWindowDetails?.sip_login_id?.toString())
      };
      if (socketService.current) {
        socketService?.current?.chatTypingStatusUpdate(data);
      }
      if (typingTimer) {
        clearTimeout(typingTimer);
        typingTimer = null;
      }

      typingTimer = setTimeout(() => {
        let data = {
          from: userDetails?.fromID.toString(),
          to: chatWindow?.chatWindowDetails?.team_id
            ? teamMembers?.toString()
            : chatWindow?.chatWindowDetails?.sip_login_id?.toString(),
          chatId: chatWindow?.chatWindowDetails?.team_id
            ? chatWindow?.chatWindowDetails?.team_id?.toString()
            : generateChatID(userDetails?.fromID, chatWindow?.chatWindowDetails?.sip_login_id?.toString())
        };
        socketService?.current?.chatTypingStopped(data);
        isTypingOn.current = 0;
      }, 4000);
    }
    if (textInfo) {
      let textInf: any = document.getElementById("textedited")?.innerHTML || "";
      draftRef.current = setTimeout(() => {
        debounceFn(textInf);
      }, 1000);
    } else {
      DraftService.removeDraftMessage(chatWindowDetails, textInfo);
    }

    let value = textInfo;

    // let len = value.length;
    // len = len === 0 ? 0 : len - 1;
    var input: any = document.getElementById("textedited");
    let iindex: any = input !== null ? getCaretCharacterOffsetWithin(input) : 0
    let lastWord = getlastWord(value);
    const currentChar = value.substr(value.length - 1);
    let lastNav = event.nativeEvent?.data;
    if ((lastWord.includes("@") || lastNav === '@') && chatWindowDetails?.team_id) {

      const lastChar = value.substr(value.length - 1);
      // const currentChar = value.substr(value.length - 1);
      const spaceCheck = /[^@A-Za-z_]/g;
      if (value.length === 0) {
        let update_info = { ...messageInfo };

        update_info.isMention = false;
        update_info.textMessage = textInfo;

        setMessageInfo(update_info);
        setMessageInfo({ ...messageInfo, isMention: false, textMessage: strRes });
      } else {

        if (spaceCheck.test(lastChar) && currentChar !== "@" && lastNav !== '@') {

          setMessageInfo({ ...messageInfo, isMention: false, textMessage: strRes });
        } else {

          const checkSpecialChar = currentChar.match(/[^@A-Za-z_]/);
          if (checkSpecialChar === null || currentChar === "@" || lastNav === '@') {
            const pattern = new RegExp(`\\B@[a-z0-9_-]+|\\B@`, `gi`);
            const matches = lastWord.match(pattern) || [];
            //let lastNav = event.nativeEvent?.data;
            if (matches.length > 0 || lastNav === '@') {
              let filter_teamMembers = getUserSuggestions(messageInfo.teammemberdetails, matches[matches.length - 1]);
              setMessageInfo({
                ...messageInfo,
                isMention: true,
                copypaste: false,
                textMessage: strRes,
                mentionIndex: iindex !== value?.length ? iindex : 0,
                searchmemberdetails: iindex !== value?.length ? messageInfo.teammemberdetails : filter_teamMembers
              });
            } else {

              if (currentChar === "@" || lastNav === '@') {
                setMessageInfo({
                  ...messageInfo,
                  isMention: true,
                  copypaste: false,
                  textMessage: strRes,
                  searchmemberdetails: messageInfo.teammemberdetails
                });
              } else {
                setMessageInfo({
                  ...messageInfo,
                  isMention: false,
                  copypaste: false,
                  textMessage: strRes,
                  searchmemberdetails: messageInfo.teammemberdetails
                });
              }
            }
          } else if (checkSpecialChar != null) {
            setMessageInfo({
              ...messageInfo,
              isMention: false,
              copypaste: false,
              textMessage: strRes
            });
          }
        }
      }
    } else {

      setMessageInfo({
        ...messageInfo,
        isMention: false,
        textMessage: strRes,
        emojiIndex: str?.length,
        copypaste: false,
        searchmemberdetails: messageInfo?.teammemberdetails
      });

    }



    if (!isReply && !isEditing && ((textClr.offsetHeight - 54) !== windowResize) && filesAttach?.length === 0) {
      chatWindowResize(textClr.offsetHeight);
    }


  };

  const hideAttachment = () => {
    setOpeAttachModal(false);
  };

  //   const stopTyping = () => {
  //     let data = {
  //       from: userDetails?.fromID.toString(),
  //       to: chatWindow.chatWindowDetails.team_id ? teamMembers?.toString() : chatWindow.chatWindowDetails?.sip_login_id?.toString(),
  //       chatId: chatWindow.chatWindowDetails.team_id ? chatWindow.chatWindowDetails?.team_id : ''
  //     };

  //       socketService.current.chatTypingStopped(data);
  //     isTypingOn.current=0;
  // }
  //   const upKey=_.debounce((e:any)=>{
  //     // debounceFnTypingStop();
  //     stopTyping();
  //   },2000)

  useEffect(() => {


    if (message.text && (message?.id?.message?.messageType === 'TEXT' || message?.id?.message?.messageType === 'AT_MENTION')) {
      let textInfo: any = document.getElementById("textedited") || "";
      textInfo.innerHTML = message?.text;
      setMessageInfo({
        ...messageInfo,
        textMessage: textInfo.innerHTML,
        teammemberdetails: chatWindowDetails?.teammembersdetails,
        searchmemberdetails: chatWindowDetails?.teammembersdetails
      });
    } else if (message.text && message?.id?.message?.messageType === 'IMAGE') {
      let textInfo: any = document.getElementById("textedited") || "";
      textInfo.innerHTML = message?.text?.text;
      setMessageInfo({
        ...messageInfo,
        textMessage: textInfo.innerHTML

      });
      updateFileAttach([message.text])
    } else if (isReply) {
      chatWindowResize(190);
    } else {
      let textInfo: any = document.getElementById("textedited");
      if (textInfo !== null) {
        textInfo.focus();
        var test = draftContact?.length === 0 ? "" : messageInfo?.textMessage
        textInfo.textContent = test;
      }
      if (draftContact.length > 0) {
        setRangeFocus();
      }
      let text = messageInfo?.textMessage?.replace(/(<([^>]+)>)|&nbsp;/gi, "");
      setMessageInfo({
        ...messageInfo,
        textMessage: text !== "" ? text : "",
        teammemberdetails: chatWindowDetails?.teammembersdetails,
        searchmemberdetails: chatWindowDetails?.teammembersdetails
      });
      chatWindowResize(filesAttach?.length > 0 ? 94 : 54);
    }
    if (!isNewMessageWindow) {
      var input: any = document.getElementById("textedited");
      if (input !== null) {
        input.focus();
      }
    }
    if (isEditing) {
      chatWindowResize(94);
      setRangeFocus();
    }

    messageInfo.showRecorder && closeRecorder();
    // return (() => {
    //   console.log("unmountcalling");
    //   closeRecorder();
    // })
    setAiMsgOpt("Formal");
    store.dispatch({
      type:Types.STORE_COMPOSED_MSG,
      payload:{
        composedMsg:{}
      }
    })
    setSelection({...selection,startIdx:-1,endIdx:-1});
    setWord("");
  }, [JSON.stringify(editMessageDetails), chatwindowDetails, isReply]);

  const setRangeFocus = () => {
    const el: any = document.getElementById('textedited');
    const selection: any = window.getSelection();
    const range = document.createRange();
    if (el !== null) {
      selection.removeAllRanges();
      range.selectNodeContents(el);
      range.collapse(false);
      selection.addRange(range);
      el.focus();
    }
  }

  useEffect(() => {
    if (indexValue > -1 && editDraft !== 'delete') {
      let textInfo: any = document.getElementById("textedited") || "";
      let fileArr: any = draftContact[indexValue]
      if (fileArr?.files?.length > 0 && filesAttach?.length === 0) {
        ChatService.fileUpload(fileArr?.files[0]);
        textInfo.innerHTML = "";
        setMessageInfo({ ...messageInfo, textMessage: "" });
      }
      if (textInfo !== '' && fileArr?.files === undefined) {
        textInfo.innerHTML = indexValue > -1 ? draftContact[indexValue]?.msgText : "";
        setRangeFocus();
        textInfo.focus();
        setMessageInfo({ ...messageInfo, textMessage: indexValue > -1 ? draftContact[indexValue]?.msgText : "" });
      }
    } else if (editDraft === 'delete') {
      let textInfo: any = document.getElementById("textedited") || "";
      if (textInfo !== '' && messageInfo?.textMessage === "") {
        textInfo.innerHTML = "";
        textInfo.focus();
        setMessageInfo({ ...messageInfo, textMessage: '' })
      }
    } else {
      let textInfo: any = document.getElementById("textedited") || "";
      if (textInfo !== '') {
        textInfo.textContent = "";
        textInfo.innerHTML = "";
        textInfo.focus();
        setMessageInfo({ ...messageInfo, textMessage: '' })
      }
    }
  }, [editDraft, chatwindowDetails]);

  useEffect(() => {
    if (!isNewMessageWindow) {
      var input: any = document.getElementById("textedited");
      if (input !== null) {
        input.focus();
      }
    }
    if (isEmojiWindow) {
      setMessageInfo({ ...messageInfo, isEmoji: false });
    }

    if (filesAttach?.length > 0) {
      let reply = isReply ? 255 : 94
      chatWindowResize(reply);
    } else if (filesAttach?.length === 0) {
      let reply = isReply ? 215 : 54
      chatWindowResize(reply);
    }

  }, [filesAttach?.length, isEmojiWindow]);
  useEffect(() => {
    let msg = filesAttach[fileTexttype]?.txt;
    setMessageInfo({
      ...messageInfo,
      textMessage: msg

    });
  }, [fileTexttype]);


  useEffect(()=>{
    if(!_.isEmpty(composedMsg) && (chatWindowDetails.chatId === composedMsg?.toPerson || chatWindowDetails?.team_id?.toString() === composedMsg?.toPerson) )  {
   if(composedMsg?.type === "compose"){
 let text:any=messageInfo.textMessage;
 let formatted_string:any=(selection.startIdx > -1 && selection.endIdx > -1) ? `${text.substring(0,selection.startIdx)}` + `${composedMsg?.composed}` + `${text.substring(selection.endIdx)}`: composedMsg?.composed;
     messageInfo.textMessage = formatted_string;
   }
   else{
     messageInfo.textMessage=composedMsg?.composed;
   }
   setMessageInfo({
     ...messageInfo,
     textMessage: messageInfo.textMessage
   });
   setSelection({...selection,startIdx:-1,endIdx:-1})
   const textClr: any = document.getElementById('textedited');
   textClr.innerHTML =messageInfo.textMessage
 }
 },[JSON.stringify(composedMsg)])

 useEffect(()=>{
  if(aiAssistMessage){
    messageInfo.textMessage = aiAssistMessage;
  setMessageInfo({
    ...messageInfo,
    textMessage: messageInfo.textMessage
  });
  const textClr: any = document.getElementById('textedited');
  if(textClr){
    textClr.innerHTML =messageInfo.textMessage;}}
 },[intent,aiAssistMessage,chatwindowDetails])
  const bold = (
    <div>
      <p>Bold</p>
      <div className="cntrlBtn">
        <span>{navigator?.userAgent?.indexOf("Mac OS X") !== -1 ? "⌘" : "ctrl"}</span>
        <span>B</span>
      </div>
    </div>
  );
  const italic = (
    <div>
      <p>Italic</p>
      <div className="cntrlBtn">
        <span>{navigator?.userAgent?.indexOf("Mac OS X") !== -1 ? "⌘" : "ctrl"}</span>
        <span>I</span>
      </div>
    </div>
  );
  const strickout = (
    <div>
      <p>Strikethrough</p>
      <div className="cntrlBtn">
        <span>{navigator?.userAgent?.indexOf("Mac OS X") !== -1 ? "⌘" : "ctrl"}</span>
        <span>shift</span>
        <span>B</span>
      </div>
    </div>
  );
  const link = (
    <div>
      <p>Link</p>
      <div className="cntrlBtn">
        <span>{navigator?.userAgent?.indexOf("Mac OS X") !== -1 ? "⌘" : "ctrl"}</span>
        <span>shift</span>
        <span>U</span>
      </div>
    </div>
  );
  const unorderedlist = (
    <div>
      <p>Bulleted List</p>
      <div className="cntrlBtn">
        <span>{navigator?.userAgent?.indexOf("Mac OS X") !== -1 ? "⌘" : "ctrl"}</span>
        <span>shift</span>
        <span>7</span>
      </div>
    </div>
  );
  const orderedlist = (
    <div>
      <p>Ordered List</p>
      <div className="cntrlBtn">
        <span>{navigator?.userAgent?.indexOf("Mac OS X") !== -1 ? "⌘" : "ctrl"}</span>
        <span>shift</span>
        <span>8</span>
      </div>
    </div>
  );
  const blockQuotes = (
    <div>
      <p>Block Quote</p>
      <div className="cntrlBtn">
        <span>{navigator?.userAgent?.indexOf("Mac OS X") !== -1 ? "⌘" : "ctrl"}</span>
        <span>shift</span>
        <span>9</span>
      </div>
    </div>
  );
  const attachFile = (
    <div>
      <p>Attach file</p>
      <div className="cntrlBtn">
        <span>alt</span>
        <span>U</span>
      </div>
    </div>
  );

  const audioRec = (
    <div>
      <p>Audio Record</p>
      <div className="cntrlBtn">
        <span>alt</span>
        <span>A</span>
      </div>
    </div>
  );
  const content = (
    <>
      <URChatAttached hideAttach={hideAttachment} inputFileRef={inputFileRef} />
    </>
  );
  const Emoji = (
    <>
      <URChatEmoji handleEmoji={handleEmojiChange} isEditing={isEditing} />
    </>
  );

  // const selectMsgComposerOpt=(type:any)=>{
  //   setAiMsgOpt(type);
  // }
  const msgcomposercontent=(<div
  className="customPopOver">
<div onClick={()=>selectMsgComposerOpt("Formal")}>Formal</div>
<div onClick={()=>selectMsgComposerOpt("Informal")}>Friendly</div>
<div onClick={()=>selectMsgComposerOpt("Expand")}>Expand</div>
<div onClick={()=>selectMsgComposerOpt("Concise")}>Concise</div>
</div>)
;
 
  const openTask = (status: boolean) => {
    chatSideWindow(status, "task", {});
    setOpenEventModal(status);
  };

  const openEvent = (status: boolean) => {
    chatSideWindow(status, "event", {});
    setOpenEventModal(status);
  };

  const openRecorder = () => {
    if (!messageInfo.showRecorder) {
      recording.recorder
        .start()
        .then((res: any) => {
          setMessageInfo({ ...messageInfo, showRecorder: !messageInfo.showRecorder });
        })
        .catch((e: any) => {
          toastInformation("Can't find your microphone");
        });
    }
    else {
      recording.recorder.stop();
      setMessageInfo({ ...messageInfo, showRecorder: false });
    }
  };

  const closeRecorder = () => {
    try {
      recording.recorder.stop();
      setMessageInfo({ ...messageInfo, showRecorder: false });
    } catch (e: any) {
      console.log("e", e);
      toastInformation(e, "failure");
      setMessageInfo({ ...messageInfo, showRecorder: false });
    }
  };

  const getAttach = (e: any) => {
    setShowAttachToolTip(e);
  }

  const setAttach = () => {
    setOpeAttachModal(!showAttach);
    if (!showAttach) setShowAttachToolTip(false)
  };

  const openNote = (status: boolean) => {
    chatSideWindow(status, "notes", {});
    setOpenEventModal(status);
  };
  const closeEditWindow = () => {
    ChatService.onChangeEditWindow(false, "");
    updateFileAttach([]);
    setMessageInfo({
      ...messageInfo,
      textMessage: "",
      isMention: false,
      isGif: false,
      isSticker: false,
      mentionUsers: []
    });
  };

  const closeReplyWindow = () => {
    ChatService.onChangeReplyWindow(false, "");
    chatWindowResize(54);
  };

  const handleSelection=()=>{
        var input: any = document.getElementById("textedited");
    let iindex: any = input !== null ? getCaretCharacterOffsetWithin(input) : 0
    setMessageInfo({ ...messageInfo, emojiIndex: iindex, txtleng: messageInfo.textMessage?.length });
    var selection:any=window.getSelection();
    var selected_txt: any = window.getSelection()?.toString().trim();
  if(selected_txt){
    setWord(selected_txt ? selected_txt: ''); 
    const range = selection.getRangeAt(0);

    const start = range.startOffset;
    const end = range.endOffset;
    if (start >= 0 && end >= 0){
    setSelection({...selection,startIdx:start < end ? start : end,endIdx:start > end ? start : end})
    }}
  }

  // const handleKeyUp = (event: any) => {
  //   var input: any = document.getElementById("textedited");
  //   let iindex: any = input !== null ? getCaretCharacterOffsetWithin(input) : 0
  //   setMessageInfo({ ...messageInfo, emojiIndex: iindex, txtleng: messageInfo.textMessage?.length });
  //   var selection:any=window.getSelection();
  //   var selected_txt: any = window.getSelection()?.toString().trim();
  //   // setWord(selected_txt ? selected_txt: ''); 
  //   // setWord(selected_txt); 


  //                 /* commented for selecting text within 50 milliseconds need to test    */

  // //   setTimeout(() => {
  // //     const selection = window.getSelection();
  // //     if (selection) {
  // //         let selectedText = selection.toString().trim();
  // //         if (selectedText) {
  // //             console.log("Selected text:", selectedText);
  // //             setWord(selectedText ? selectedText: "welcome12345");
  // //         } else {
  // //             console.log("No text selected or selection is empty");
  // //         }
  // //     } else {
  // //         console.log("No text selected");
  // //     }
  // // }, 50);

  //   //             const range = selection.getRangeAt(0);
  //   //             const start = range.startOffset;
  //   //             const end = range.endOffset;
  //   // if (start >= 0 && end >= 0){
  //   //   setSelection({...selection,startIdx:start < end ? start : end,endIdx:start > end ? start : end})
  //   // }



  //   // if(event.keyCode===8){
  //   //   let data = {
  //   //     from: userDetails?.fromID.toString(),
  //   //     to: chatWindow.chatWindowDetails.team_id ? teamMembers?.toString() : chatWindow.chatWindowDetails?.sip_login_id?.toString(),
  //   //     chatId: chatWindow.chatWindowDetails.team_id ? chatWindow.chatWindowDetails?.team_id.toString() : ''
  //   //   };
  //   //   socketService.current.chatTypingStopped(data);
  //   // }
  // };
  const onSaveDraft = () => {
    if (messageInfo?.textMessage?.trim() !== "" || filesAttach?.length > 0) {
      DraftService.updateDraftMessage(chatWindowDetails, messageInfo.textMessage);
      isEditing ? closeEditWindow() : closeReplyWindow();
      toastInformation("Draft Saved");
    }
    if (filesAttach?.length > 0) {
      updateFileAttach([]);
    }
  };

  const setEmoji = () => {
    setMessageInfo({
      ...messageInfo,
      isEmoji: !messageInfo.isEmoji,
      isGif: false,
      isSticker: false
    })
  };

  let teamMemberOnly =
    chatWindowDetails?.team_members && chatWindowDetails?.team_members
      ? chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim())
      : [];
  let keysData =
    Object.keys(typingList) && Object.keys(typingList).length > 0
      ? Object.values(typingList)
        .map((value: any) => {
          if (
            value?.msgType === 2 &&
            parseInt(chatWindowDetails?.team_id) === parseInt(value?.chatId) &&
            value?.participants
          ) {
            return Object.values(value.participants)
              .map((value: any) => value?.caller_id)
              .toString();
          } else {
            return null;
          }
        })
        .filter((value) => value)
      : [];
  // console.log("Keys Data --->", keysData);

  const sendAudio = () => {
    let filesinfo: any = {};
    recording.recorder
      .stop()
      .getMp3()
      .then(([buffer, blob]: any) => {
        const file = new File(buffer, "me-at-thevoice.mp3", {
          type: blob.type,
          lastModified: Date.now()
        });
        filesinfo.fileName = file.name;
        filesinfo.fileType = file.type;
        filesinfo.filePath = window.URL.createObjectURL(file);
        filesinfo.filesize = file.size;
        filesinfo.targetFile = file;
        filesinfo.isCloudfiles = false
        fileUploadSocket(filesinfo);
      });
    closeRecorder();
  };

  const boldTextContent = (type: any) => {
    let removeArr;
    var edit: any = document.getElementById("textedited");
    edit.focus();
    document.execCommand(type, false, '');
    var str = edit.innerHTML.replace(/<\/?span[^>]*>/g, "");
    let index: any = messageInfo.activeType.findIndex((elem: any) => (elem === type));
    let arrType: any = messageInfo.activeType;
    if (index !== -1) {
      let index: any = messageInfo.activeType.findIndex((elem: any) => (elem === type));
      messageInfo.activeType.splice(index, 1)

      setMessageInfo({
        ...messageInfo,
        activeType: messageInfo.activeType, textMessage: str

      });
    } else {
      if(type === 'insertOrderedList'){
        removeArr = _.filter(messageInfo.activeType,(data: any)=> data !== 'insertUnorderedList')
        removeArr.push(type)
        setMessageInfo({
          ...messageInfo,
          activeType:removeArr, textMessage: str
        });
      }else if(type === 'insertUnorderedList'){
        removeArr = _.filter(messageInfo.activeType,(data: any)=> data !== 'insertOrderedList')
        removeArr.push(type)
        setMessageInfo({
          ...messageInfo,
          activeType:removeArr, textMessage: str
        });
      }else{
        arrType.push(type);
        setMessageInfo({
          ...messageInfo,
          activeType: arrType, textMessage: str
        });
      }
    }
  }
  const blockFormatContent = (type: any) => {
    var edit: any = document.getElementById("textedited");
    edit.focus();
    let block = '<blockquote>';
    let nonblock = '<p>'
    let arrType: any = messageInfo.activeType;
    let index: any = arrType.findIndex((elem: any) => (elem === type));
    if (index !== -1) {
      let index: any = messageInfo.activeType.findIndex((elem: any) => (elem === type));
      messageInfo.activeType.splice(index, 1)
      document.execCommand(type, false, nonblock);
      let text = messageInfo?.textMessage?.replace(/(<([^>]+)>)|&nbsp;/gi, "");
      setMessageInfo({
        ...messageInfo,
        textMessage: text !== "" ? text : "", activeType: messageInfo.activeType

      });
    }
    else {
      arrType.push(type);
      document.execCommand(type, false, block);
      let text = messageInfo?.textMessage?.replace(/(<([^>]+)>)|&nbsp;/gi, "");
      setMessageInfo({
        ...messageInfo,
        textMessage: edit.innerHTML, activeType: arrType
      });
    }


  }


  const getAIMessage=()=>{
   let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    if(messageInfo.textMessage === undefined ||  messageInfo.textMessage?.trim()===""){getUnreadCompose(chatWindow.chatWindowDetails);}
  }


  const handleLinkCancel = () => {
    setIsModalVisible1(false);

  }
  const handlePaste = () => {
    setMessageInfo({
      ...messageInfo,
      copypaste: true
    });
  }

  
  const preventDragHandler = (e:any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const gotoBottom = (id: string, scrollPos?: any) => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      let heightScroll = element.scrollHeight;
      element.scrollTop = scrollPos ? -scrollPos : heightScroll;
    }
  };
  const setEmoiOpen = () => {
    setModal1Open(false)
    var edit: any = document.getElementById("textedited");
    setRangeFocus();
    edit.focus();
  }

  const handleMouseUp=()=>{
    console.log("calleddd");
    handleSelection();
    document.removeEventListener('mouseup', handleMouseUp);

  }

  const handleMouseDown=()=>{
    document.addEventListener('mouseup', handleMouseUp);
  }

  const chatbotClr: any = document.getElementById('chatbot');
  let bbott: any = chatbotClr?.offsetHeight;
  return (
    <>
      {/* Typing Status don't remove the code */}
      {/* {chatWindowDetails?.team_id && Array.isArray(keysData) && keysData.length > 0 ? (
        <div className={styles.typingStatus}>
          <span className={styles.name}>{_.startCase(_.toLower(keysData.join(",")))}</span> is typing...
        </div>
      ) : (
        chatWindowDetails?.sip_login_id &&
        typingList?.[chatWindowDetails?.sip_login_id] && (
          <div className={styles.typingStatus}>
            <span className={styles.name}>{typingList?.[chatWindowDetails?.sip_login_id]?.caller_id}</span> is typing...
          </div>
        )
      )} */}
      {/* BACK TO RECENT MSG ARROW FUNC */}
      {scroll < -10 && <div onClick={() => gotoBottom("chatWindow")} className={styles.downarrowrightsec}>
        <Tooltip placement="leftBottom" mouseEnterDelay={0.5} title={"Recent Message"}>
          <span className={styles.edEvents} ></span>
          <span className="icon_downarrow">
          {countValue > 0 && <span className="stsDotunread">{countValue}</span>}
          </span>
        </Tooltip>
      </div>}

      {/* need to handle */}
      {messageInfo?.showRecorder && <ChatAudioRecording closeRecorder={closeRecorder} convertAudio={sendAudio} />}
      {/* <Createevent openEvent={openEvent} open={showEvent}/> */}
      {/* <Createtask openTask={openTask} open={showTask} /> */}
      {/* <Createnote openNote={openNote} open={showNote}/> */}

      {isReply ? (
        <div className={styles.replySec}>
          <div className={styles.replySecHeader}>
            <span className={styles.replySecName}>
              <img src={replyIcon} alt="" /> Replying
            </span>
            <div className={styles.rightSec}>
              <URButton className="urButton buttonWhite button26" name="Save Draft" onClick={() => onSaveDraft()} />
              <Tooltip mouseEnterDelay={0.5} title={"Close"}>
                <span className={styles.replySecClose}>
                  <span className="icon_close" onClick={() => closeReplyWindow()}></span>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      ) : null}
      {isEditing ? (<div className={styles.editSec}>
        <div className={styles.editSecHeader}>
          <span className={styles.editSecName}><span className="edittingIcon"></span> Editing</span>
          <div className={styles.rightSec}>
            <URButton onClick={() => onSaveDraft()} className='urButton buttonWhite button26' name='Save Draft' />
            <Tooltip mouseEnterDelay={0.5} placement="top" title={'Close'}>
              <span className={styles.editSecClose} onClick={() => closeEditWindow()}><span className="icon_close"></span></span>
            </Tooltip>
          </div>
        </div>
      </div>
      ) : null}
      {isReply ? (
        <div className={styles.replyArea}>
          <ChatReplyInner isBottom={true} replyingMessage={replymessage} />
        </div>
      ) : null}
      {teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim()) ||
        ((chatWindowDetails?.is_blocked === undefined || chatWindowDetails?.is_blocked === 0) && chatWindowDetails?.sip_login_id && deleteContact[chatWindowDetails?.sip_login_id] === undefined) ||
        ((chatWindowDetails?.is_blocked === undefined || chatWindowDetails?.is_blocked === 0) && isNewMessageWindow && !chatWindowDetails?.leaveTeamMembers) ? (
        <div className={`${messageInfo.textMessage ? `${styles.active} ${styles.editorBottom}` : styles.editorBottom}`}>

          {/* <div className={styles.shareArea}>
          <ChatShareInner />
        </div>  */}

          {messageInfo.isMention ? (
            <URAtMention teammemberlist={messageInfo.searchmemberdetails} appenduser={appendMentionUser} />
          ) : null}

          {/* <div className={styles.editorTextarea}>
            <URTextAreas
              id="my-input"
              autofocus
              onChange={(e: any) => onUpdateMessage(e)}
              placeHolder={
                isNewMessageWindow
                  ? "Send a message"
                  : isReply
                  ? "Reply"
                  : `${"Send a message to"} ${
                      chatWindowDetails?.team_id
                        ? _.upperFirst(chatWindowDetails?.team_name)
                        : _.uniq(multiMemberList).join(", ")
                    }`
              }
              onKeyUp={handleKeyUp}
              onKeyDown={handleKeyPress}
              value={messageInfo.textMessage}
            />
          </div> */}
          <div className={styles.editorTextarea}>
            {/* <URTextAreas
            
              autofocus
              onChange={(e: any) => onUpdateMessage(e)}
              placeHolder={
                isNewMessageWindow
                  ? `${"Send a Message To"} ${
                      chatWindowDetails?.team_id
                        ? _.upperFirst(chatWindowDetails?.team_name)
                        : _.uniq(multiMemberList).join(", ")
                    }`
                  : isReply
                  ? "Reply"
                  : `${"Send a message to"} ${
                      chatWindowDetails?.team_id
                        ? _.upperFirst(chatWindowDetails?.team_name)
                        : _.upperFirst(chatWindowDetails?.caller_id)
                    }`
              }
              onKeyUp={handleKeyUp}
              onKeyDown={handleKeyPress}
             
            /> */}
            
            
            <div className={`scroller ${styles.textAreaSec}`} contentEditable={dropdownNewChat} id="textedited"
              onMouseDown={handleMouseDown}
              placeholder={
                isNewMessageWindow
                  ? `${"Send a Message To"} ${chatWindowDetails?.team_id
                    ? _.upperFirst(chatWindowDetails?.team_name)
                    : _.uniq(multiMemberList).join(", ")
                  }`
                  : isReply
                    ? "Reply"
                    : `${"Send a message to"} ${chatWindowDetails?.team_id
                      ? _.upperFirst(chatWindowDetails?.team_name)
                      : _.upperFirst(chatWindowDetails?.caller_id)
                    }`
              }
              onInput={(e: any) => onUpdateMessage(e)}
              onKeyDown={handleKeyPress}
              onPaste={handlePaste}
              suppressContentEditableWarning={true}
            >
              
            </div>

        
      
            {/* <div id={"textedited"} tabIndex={0} className={`scroller ${styles.textAreaSec}`}  
            onInput={onKeyPressed}  contentEditable>
           
            </div> */}
          
           <div className={styles.editorai} onClick={getAIMessage}>
                <Dropdown overlay={menuai}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none">
                    <path d="M11.6964 1.64486L10.8376 0.796658C10.6427 0.604191 10.3888 0.508058 10.1349 0.508058C9.87689 0.508125 9.61903 0.607324 9.42336 0.805391L1.02563 9.30792C0.637492 9.70086 0.641492 10.334 1.03443 10.7221L1.89329 11.5704C2.08816 11.7629 2.34209 11.859 2.59596 11.859C2.85396 11.859 3.11183 11.7597 3.30749 11.5617L11.7052 3.05912C12.0933 2.66619 12.0894 2.03292 11.6964 1.64486ZM2.59603 10.8589L1.73716 10.0107L7.62916 4.04452L8.48989 4.89146L2.59603 10.8589ZM9.19256 4.17999L8.33183 3.33299L10.134 1.50819L10.1349 1.50812L10.9938 2.35632L9.19256 4.17999Z" fill="#575CFF" />
                    <path d="M11.8963 8.85152C11.9608 8.89479 11.9931 8.94819 11.9931 9.01286C11.9931 9.07739 11.9608 9.13139 11.8963 9.17419L10.6054 9.69053L10.089 10.9815C10.0456 11.046 9.99223 11.0783 9.92756 11.0783C9.86303 11.0783 9.80916 11.0459 9.76623 10.9815L9.24989 9.69053L7.95896 9.17419C7.89443 9.13139 7.86216 9.07739 7.86216 9.01286C7.86216 8.94819 7.89449 8.89479 7.95896 8.85152L9.24989 8.33506L9.76623 7.04412C9.80916 6.97959 9.86303 6.94746 9.92756 6.94746C9.99223 6.94746 10.0456 6.97966 10.089 7.04412L10.6054 8.33506L11.8963 8.85152Z" fill="#575CFF" />
                    <path d="M4.04036 3.11412C4.10489 3.15739 4.13716 3.21079 4.13716 3.27546C4.13716 3.33999 4.10483 3.39399 4.04036 3.43679L2.74943 3.95312L2.23309 5.24406C2.18969 5.30859 2.13629 5.34086 2.07163 5.34086C2.00709 5.34086 1.95323 5.30852 1.91029 5.24406L1.39396 3.95312L0.103026 3.43679C0.0384923 3.39399 0.00622559 3.33999 0.00622559 3.27546C0.00622559 3.21079 0.0385589 3.15739 0.103026 3.11412L1.39396 2.59766L1.91029 1.30672C1.95323 1.24219 2.00709 1.21006 2.07163 1.21006C2.13629 1.21006 2.18969 1.24226 2.23309 1.30672L2.74943 2.59766L4.04036 3.11412Z" fill="#575CFF" />
                    <path d="M7.22996 1.39646C7.27249 1.42499 7.29383 1.46019 7.29383 1.50286C7.29383 1.54539 7.27249 1.58099 7.22996 1.60926L6.37876 1.94972L6.03829 2.80092C6.00969 2.84346 5.97443 2.86479 5.93183 2.86479C5.88929 2.86479 5.85376 2.84346 5.82543 2.80092L5.48496 1.94972L4.63376 1.60926C4.59123 1.58106 4.56989 1.54539 4.56989 1.50286C4.56989 1.46026 4.59123 1.42499 4.63376 1.39646L5.48496 1.05592L5.82543 0.204724C5.85376 0.162191 5.88929 0.140991 5.93183 0.140991C5.97443 0.140991 6.00969 0.162191 6.03829 0.204724L6.37876 1.05592L7.22996 1.39646Z" fill="#575CFF" />
                  </svg>
                </Dropdown>
          </div>
          </div>

          {/* need to handle */}

          {filesAttach.length > 0 && <ChatBottomAttachments nameValue={messageInfo.textMessage} />}

          <div className={styles.editorToolbar}>
            <div className={styles.editorscroll}>
              <Menu mode="horizontal" className="bottomicons">
                <Menu.Item key={1}>
                  <div className={messageInfo.showRecorder ? `${styles.iconSet} ${styles.iconDisabled}` : styles.iconSet}>
                    <Tooltip mouseEnterDelay={0.5} placement="top" title={"Emoji"}>
                      <div onClick={() => setModal1Open(true)}>
                        <span
                          onClick={() => setEmoji
                          }
                          className={messageInfo.isEmoji ? `${styles.attachactive} ${styles.edEmoji}` : styles.edEmoji}
                        >
                          <span className="iconSmily"></span>
                        </span>
                      </div>
                    </Tooltip>
                    <Divider type="vertical" className="vbdr" />
                  </div>
                </Menu.Item>
                <Menu.Item key={2}>
                  <div className={messageInfo.showRecorder ? `${styles.iconSet} ${styles.iconDisabled}` : styles.iconSet}>
                    <Popover
                      placement="top"
                      mouseEnterDelay={0.5}
                      content={bold}
                      trigger="hover"
                      overlayClassName="popoverBlack"
                    >
                      <a id="bold" href="#/" className={styles.eddbold} onClick={() => boldTextContent('bold')}>
                        <span className={`${styles.edbold} ${styles.active}`}>
                          <span className={_.includes(messageInfo.activeType, 'bold') ? `${"iconBold"} ${styles.active}` : "iconBold"}></span>
                        </span>
                      </a>
                    </Popover>
                    <Popover
                      placement="top"
                      mouseEnterDelay={0.5}
                      content={italic}
                      trigger="hover"
                      overlayClassName="popoverBlack"
                    >
                      <a id="italic" href="#/" className={styles.eddbold} onClick={() => boldTextContent('italic')}>
                        <span className={styles.edItalic}>
                          <span className={_.includes(messageInfo.activeType, 'italic') ? `${"iconItalic"} ${styles.active}` : "iconItalic"}></span>
                        </span>
                      </a>
                    </Popover>
                    <Popover
                      placement="top"
                      mouseEnterDelay={0.5}
                      content={strickout}
                      trigger="hover"
                      overlayClassName="popoverBlack"
                    >
                      <a id="strikeThrough" href="#/" className={styles.eddbold} onClick={() => boldTextContent('strikeThrough')}>
                        <span className={styles.edstrickout}>
                          <span className={_.includes(messageInfo.activeType, 'strikeThrough') ? `${"iconStrike"} ${styles.active}` : "iconStrike"} ></span>
                        </span>
                      </a>
                    </Popover>

                    <Popover
                      placement="top"
                      mouseEnterDelay={0.5}
                      content={orderedlist}
                      trigger="hover"
                      overlayClassName="popoverBlack"
                    >
                      <a id="insertOrderedList" href="#/" className={styles.eddbold} onClick={() => boldTextContent('insertOrderedList')}>
                        <span className={styles.unorderList}>
                          <span className={_.includes(messageInfo.activeType, 'insertOrderedList') ? `${"iconBullet"} ${styles.active}` : "iconBullet"} ></span>
                        </span>
                      </a>
                    </Popover>
                    <Popover
                      placement="top"
                      mouseEnterDelay={0.5}
                      content={unorderedlist}
                      trigger="hover"
                      overlayClassName="popoverBlack"
                    >
                      <a id="insertUnorderedList" href="#/" className={styles.eddbold} onClick={() => boldTextContent('insertUnorderedList')}>
                        <span className={styles.orderList}>
                          <span className={_.includes(messageInfo.activeType, 'insertUnorderedList') ? `${"iconNumberlist"} ${styles.active}` : "iconNumberlist"} ></span>
                        </span>
                      </a>
                    </Popover>
                    <Popover
                      placement="top"
                      mouseEnterDelay={0.5}
                      content={blockQuotes}
                      trigger="hover"
                      overlayClassName="popoverBlack"
                    >
                      <a id="formatBlock" href="#/" className={styles.eddbold} onClick={() => blockFormatContent('formatBlock')}>

                        <span className={styles.edQuote}>
                          <span className={_.includes(messageInfo.activeType, 'formatBlock') ? `${"iconQutation"} ${styles.active}` : "iconQutation"}></span>
                        </span>
                      </a>
                    </Popover>
                    <Divider type="vertical" className="vbdr" />
                  </div>
                </Menu.Item>
                <Menu.Item key={3}>
                  <div className={messageInfo.showRecorder ? `${styles.iconSet} ${styles.iconDisabled}` : styles.iconSet}>
                    <Popover
                      placement="top"
                      mouseEnterDelay={0.5}
                      content={link}
                      trigger="hover"
                      overlayClassName="popoverBlack"
                    >
                      <span className={styles.edlink} onClick={showModal1}>
                        <span className="iconLinkRotate"></span>
                      </span>
                    </Popover>
                    <Divider type="vertical" className="vbdr" />
                  </div>
                </Menu.Item>
                {/* <Menu.Item key={4}>
                  <div className={(messageInfo.showRecorder || isEditing) ? `${styles.iconSet} ${styles.iconDisabled}` : styles.iconSet}>
                    <Tooltip placement="top" mouseEnterDelay={0.5} title={"New Task"} className="cusTooltip"
                      overlayClassName="customTooltip">
                      <span className={styles.edTask} onClick={() => openTask(true)}>
                        <span className="iconTickNote"></span>
                      </span>
                    </Tooltip>
                  <Tooltip placement="top" mouseEnterDelay={0.5} title={"New Event"} className="cusTooltip"
                      overlayClassName="customTooltip">
                      <span  className={styles.edEvents} onClick={() => openEvent(true)}>
                        <span className="iconEvent"></span>
                      </span>
                    </Tooltip>
                    <Tooltip placement="top" mouseEnterDelay={0.5} title={"New Note"} className="cusTooltip"
                      overlayClassName="customTooltip">
                      <span className={styles.edNotes}  onClick={() => openNote(true)}>
                        <span className="iconNote"></span>
                      </span>
                    </Tooltip>


                    <Divider type="vertical" className="vbdr" />
                  </div>
                </Menu.Item> */}
                <Menu.Item key={5}>
                  <div className={(isEditing) ? `${styles.iconSet} ${styles.iconDisabled}` : styles.iconSet}>
                    <div className={messageInfo.showRecorder ? `${styles.iconDisabled}` : ''}>
                      <Popover
                        content={content}
                        overlayClassName="customDragdrop fileattach"
                        onVisibleChange={setAttach}
                        trigger="click"
                        visible={showAttach}
                      >
                        <Popover
                          mouseEnterDelay={0.5}
                          placement="top"
                          content={attachFile}
                          trigger="hover"
                          overlayClassName="popoverBlack"
                          onVisibleChange={getAttach}
                          visible={showAttachToolTip}
                        >
                          <span
                            className={showAttach ? `${styles.attachactive} ${styles.edAttachment}` : styles.edAttachment}
                          >
                            <span className='iconAttach'></span>
                          </span>
                        </Popover>
                      </Popover>
                    </div>
                    <Popover
                      mouseEnterDelay={0.5}
                      placement="top"
                      content={audioRec}
                      trigger="hover"
                      overlayClassName="popoverBlack"
                    >
                      <span
                        className={
                          messageInfo.showRecorder ? `${styles.attachactive} ${styles.edVoicemail}` : styles.edVoicemail
                        }
                      >
                        <span className="iconMicroPhone" onClick={() => openRecorder()}></span>
                      </span>
                    </Popover>
                    {/* <Tooltip placement="top"  mouseEnterDelay={0.5} title={'GIF'}>
                      <Popover content={Gif} overlayClassName='customAddImage' trigger="click" onVisibleChange={setGif} visible={messageInfo.isGif} >
                        <span onClick={()=>setMessageInfo({...messageInfo,isGif:!messageInfo.isGif,isSticker:false,isEmoji:false})} 
                        className={messageInfo.isGif ? `${styles.attachactive} ${styles.edGif}` :styles.edGif}><span className="iconGif"></span></span>
                      </Popover>
                    </Tooltip>
                    <Tooltip placement="top" mouseEnterDelay={0.5} title={'Sticker'}>
                      <Popover content={Stricker} overlayClassName='customAddImage' trigger="click" onVisibleChange={setSticker} visible={messageInfo.isSticker} >
                        <span onClick={()=>setMessageInfo({...messageInfo,isSticker:!messageInfo.isSticker,isGif:false,isEmoji:false})} 
                        className={messageInfo.isSticker? `${styles.attachactive} ${styles.edPic}` :styles.edPic}><span className="iconSticker"></span></span>
                      </Popover>
                    </Tooltip> */}
                  </div>
                </Menu.Item>
              </Menu>
            </div>
            {/* <div className={styles.set1}>
            <Popover placement="top" content={bold} trigger="hover" overlayClassName="popoverBlack">
              <span className={styles.edbold}></span>
            </Popover>
            <Popover placement="top" content={italic} trigger="hover" overlayClassName="popoverBlack">
              <span className={styles.edItalic}></span>
            </Popover>
            <Popover placement="top" content={strickout} trigger="hover" overlayClassName="popoverBlack">
              <span className={styles.edstrickout}></span>
            </Popover>
            <Popover placement="top" content={link} trigger="hover" overlayClassName="popoverBlack">
              <span className={styles.edlink} onClick={showModal1}></span>
            </Popover>
            <Popover placement="top" content={orderedlist} trigger="hover" overlayClassName="popoverBlack">
              <span className={styles.unorderList}></span>
            </Popover>
            <Popover placement="top" content={unorderedlist} trigger="hover" overlayClassName="popoverBlack">
              <span className={styles.orderList}></span>
            </Popover>
            <Tooltip placement="top" title={'Animated GIF'}><span className={styles.edQuote}></span></Tooltip>
          </div>
          <span className={`${styles.edDivider} ${styles.mobilehide}`}></span>
          <div className={styles.set2}>
            <Tooltip placement="top" title={'Task'}><span className={styles.edTask}></span></Tooltip>
            <Tooltip placement="top" title={'Events'}><span className={styles.edEvents}></span></Tooltip>
            <Tooltip placement="top" title={'Notes'}><span className={styles.edNotes}></span></Tooltip>
          </div>
          <span className={styles.edDivider}></span>
          <div className={styles.set3}>
            <Popover placement="top" content={attachFile} trigger="hover" overlayClassName="popoverBlack">
              <Popover content={content} overlayClassName='customDragdrop' trigger="click">
                <span className={styles.edAttachment}></span>
              </Popover>
            </Popover>
            <Popover placement="top" content={audioRec} trigger="hover" overlayClassName="popoverBlack">
              <span className={styles.edVoicemail}></span>
            </Popover>
            <Tooltip placement="top" title={'Emoji'}>
               <Popover content={Emoji} overlayClassName='customAddImage' trigger="click">
                <span className={styles.edEmoji}></span>
              </Popover>                              
              </Tooltip>
          </div>
          <span className={styles.edDivider}></span>
          <div className={styles.set4}>
            <Tooltip placement="top" title={'Animated GIF'}>
              <Popover content={Gif} overlayClassName='customAddImage' trigger="click">
                <span className={styles.edGif}></span>
              </Popover>
              </Tooltip>
            <Tooltip placement="top" title={'Animated Stricker'}>
              <Popover content={Stricker} overlayClassName='customAddImage' trigger="click">
                <span className={styles.edPic}></span>
              </Popover>
            </Tooltip>             
          </div> */}
            {/*  {(chatReducer.fileList.length === 0)&&
        <span className={styles.sendBtn}>
        <span className="icon_sendarrow" onClick={sendMessageToXMPP}></span></span>} */}
            {Array.isArray(filesAttach) && filesAttach.length > 0 && !isReply && (
              <span
                className={`${filesAttach?.length > 0 ? ` ${styles.sendBtn}` : styles.sendBtn}`}
              >
                <div className={styles.imgcounts}>{filesAttach?.length}</div>
                <span onDragStart={preventDragHandler}  onClick={sendFileMessage}>{filesAttach.length > 0 && !isReply ? <img src={sendgreendisable} alt="" /> : <img src={sendgreen} alt="" />}</span>
              </span>
            )}
            {Array.isArray(filesAttach) && filesAttach.length === 0 && !isReply && (
              <span
                className={`${!_.isEmpty(chatWindowDetails) && messageInfo.textMessage ? ` ${styles.sendBtn}` : styles.sendBtn}`}
              >
                <span onDragStart={preventDragHandler} onClick={sendMessageToXMPP}> {messageInfo.textMessage ? <img src={sendgreendisable} alt="" /> : <img src={sendgreen} alt="" />} </span>
              </span>
            )}
            {Array.isArray(filesAttach) && filesAttach.length > 0 && isReply && (
              <span
                className={`${(filesAttach?.length > 0) ? ` ${styles.sendBtn}` : styles.sendBtn}`}
              >
                <div className={styles.imgcounts}>{filesAttach?.length}</div>
                <span onDragStart={preventDragHandler}  onClick={sendMessageToXMPP}>{filesAttach?.length > 0 && isReply ? <img src={sendgreendisable} alt="" /> : <img src={sendgreen} alt="" />}</span>
              </span>
            )}
            {Array.isArray(filesAttach) && filesAttach.length === 0 && isReply && (
              <span
                className={`${(messageInfo.textMessage) ? `${styles.sendBtn}` : styles.sendBtn}`}
              >
                <span onDragStart={preventDragHandler}  onClick={sendMessageToXMPP}>{filesAttach.length === 0 && isReply && messageInfo.textMessage ? <img src={sendgreendisable} alt="" /> : <img src={sendgreen} alt="" />}</span>
              </span>
            )}
            {/* {isReply ? (<div className={styles.replySharebtn}>
          <button>Reply</button>
        </div>):(<span className={styles.sendBtn} onClick={sendMessageToXMPP}>
          <span className="icon_sendarrow"></span></span>)} */}
          </div>
        </div>
      ) : (
        <>
          {chatWindowDetails?.is_blocked === 1 ?
            <div className={styles.leftFrmAdmindelete}>
              {userdetails?.ext?.toString() === '200' ?
                <>You have already blocked {chatWindowDetails?.caller_id} and cannot send or receive message from that person.  You can unblock {chatWindowDetails?.caller_id} from <a href=""> Settings</a></> :
                "Admin has blocked this account. You cannot chat with this contact."


              }
            </div>
            : deleteContact[chatWindowDetails?.sip_login_id] === undefined ?
              <div className={styles.leftFromTeam}>
                You can’t send messages to this group because you are no longer a member.
              </div> :
              <div className={styles.leftFrmAdmindelete}>
                You cannot send messages to this account anymore since <br /> it has been deleted by the admin.
                {/* Admin as delete this account, you cant<br/> chat with this account. */}
              </div>
          }
        </>
      )}

      {messageInfo?.textMessage && (
        <span className={styles.infoBottom}>
          <span>Enter</span> to send • <span>Shift + Enter or Alt / Option + Enter</span> to add a new line
        </span>
      )}
      {/* <div className={styles.networkError}>
          <div className={styles.errorTextCenter}>
            <div className={styles.errorTextBottom}>
               <img src={nodata} alt=""/>
              <span> UnifiedRing trying to connect…</span>
            </div>
          </div>
        </div> */}
      {/* <Modal
        title="Add link"
        centered
        visible={isModalVisible1}
        onOk={handleLinkSend}
        onCancel={handleLinkCancel}
        cancelText="Cancel"
        okText="Save"
        cancelButtonProps={{ className: "urButton buttonWhite" }}
        okButtonProps={{ className: "urButton buttonBlue" }}
        className="customPopup"
      >
        <URInputwithLabel value={messageInfo.linkText} placeHolder="Display Text" onChange={(e: any) => onUpdateLink('linkText',e)} label="Display Text" className="inputBox" />
        <URInputwithLabel value={messageInfo.linkUrl} placeHolder="URL" onChange={(e: any) => onUpdateLink('linkUrl',e)} label="URL" className="inputBox" />
      </Modal> */}
      <Modal
        style={{ bottom: bbott, position: 'absolute', paddingBottom: '2px', left: '384px', top: 'auto' }}
        visible={modal1Open}
        mask={false}
        onOk={() => setEmoiOpen()}
        onCancel={() => setEmoiOpen()}
        footer={false}
        title={false}
        closable={false}
        className="emojiPopup"
        focusTriggerAfterClose={true}
      >
        {Emoji}
      </Modal>
    </>
  );
}

export default ChatBottom;
